const PIXEL_ID = '1446146777304539'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Remove any existing pixel
  if (window.fbq) {
    delete (window as Record<string, unknown>).fbq
    delete (window as Record<string, unknown>)._fbq
  }

  // Remove any existing FB pixel scripts
  const existingScripts = document.querySelectorAll(
    'script[src*="fbevents.js"]',
  )
  existingScripts.forEach((s) => s.remove())

  // Fresh initialization
  const n = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  } as unknown as Window['fbq'] & {
    callMethod?: (...args: unknown[]) => void
    queue: unknown[][]
    push: (...args: unknown[]) => void
    loaded: boolean
    version: string
  }

  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  window.fbq = n
  window._fbq = n

  // Inject fresh script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Init pixel and fire PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackEvent(event: string, data?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, data)
  }
}

export function trackInitiateCheckout(product: string, value: number) {
  trackEvent('InitiateCheckout', {
    content_name: product,
    content_type: 'product',
    value: value,
    currency: 'ARS',
  })
}
